module.exports = __webpack_public_path__ + "media/images/flags/32/United-Arab-Emirates-a5f9046592ac3a13b1c68129357e5b07.png";